import React from 'react';
import accounting from 'accounting';

const Price = ({
  productsCarouselVersion,
  amount,
  decimalSup = false,
  decimal = 2,
}) => {
  if (!amount) {
    //return null;
  }
  if (productsCarouselVersion === 1) {
    const splitPrice = accounting
      .formatMoney(amount, '€', decimal, '.', ',')
      .split(',');
    return (
      <div>
        <span style={{ whiteSpace: 'nowrap' }}>
          {splitPrice[0]}
          <span style={{ fontSize: '14px', fontWeight: '400' }}>,</span>
          <span style={{ fontSize: '14px', fontWeight: '400' }}>
            {splitPrice[1]}
          </span>
        </span>
      </div>
    );
  }
  return (
    <div>
      <span style={{ whiteSpace: 'nowrap' }}>
        {accounting.formatMoney(amount, '€ ', decimal, '.', ',')}
      </span>
    </div>
  );
};

export default Price;
